import { render, staticRenderFns } from "./SubmitBody.vue?vue&type=template&id=3255ec90&scoped=true&"
import script from "./SubmitBody.vue?vue&type=script&lang=js&"
export * from "./SubmitBody.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBody.vue?vue&type=style&index=0&id=3255ec90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255ec90",
  null
  
)

export default component.exports